import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import "@elastic/eui/dist/eui_theme_light.css";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <EuiProvider colorMode="light">yarn star
//     <React.StrictMode>
//       <RouterProvider router={router} />
//       <App />
//     </React.StrictMode>
//   </EuiProvider>
// );

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
